document.addEventListener('DOMContentLoaded', function () {
  const storeIos = 'https://apps.apple.com/app/id6758296577';
  const storeAndroid = 'https://play.google.com/store/apps/details?id=com.billspot.billapp';

  const headerHTML = `
  <div class="nav-container">
    <div class="nav-inner">
      <a href="/" class="nav-logo">
        <img
          src="/images/logo-black-322w.png"
          srcset="/images/logo-black-168w.webp 168w, /images/logo-black-322w.webp 322w"
          sizes="92px"
          alt="BillSpot"
          width="161"
          height="74"
          decoding="async"
        />
      </a>
      <a href="${storeAndroid}" class="mobile-download-btn" target="_blank" rel="noopener noreferrer">Download</a>
      <div class="mobile-menu-toggle" role="button" tabindex="0" aria-label="Open menu">
        <span></span><span></span><span></span>
      </div>
      <div class="nav-links">
        <a href="/#services">Services</a>
        <a href="/airtime-to-cash">Airtime to Cash</a>
        <a href="/#testimonials">Testimonials</a>
        <a href="/faq">FAQ</a>
        <a href="/trust">Trust</a>
        <a href="${storeIos}" class="nav-cta" target="_blank" rel="noopener noreferrer"><span class="nav-cta-text">Download</span></a>
      </div>
    </div>
  </div>
  `;

  const path = window.location.pathname.replace(/\/$/, '') || '/';
  const isHome = path === '/' || path === '/index.html' || path.endsWith('/index.html');

  if (!document.querySelector('.skip-link') && document.getElementById('main-content')) {
    document.body.insertAdjacentHTML(
      'afterbegin',
      '<a class="skip-link" href="#main-content">Skip to content</a>'
    );
  }

  if (!document.querySelector('.nav-container')) {
    document.body.insertAdjacentHTML('afterbegin', headerHTML);
  }

  const navContainer = document.querySelector('.nav-container');
  if (!navContainer) return;

  // Inner pages: always show the sticky bar (no old hero logo to observe)
  if (!isHome || !document.querySelector('.logodiv, #hero .logodiv')) {
    navContainer.classList.add('visible');
  }

  // Mobile menu styles (shared chrome, matches homepage)
  if (!document.getElementById('site-nav-mobile-style')) {
    const mobileStyleElement = document.createElement('style');
    mobileStyleElement.id = 'site-nav-mobile-style';
    mobileStyleElement.textContent = `
      .mobile-download-btn {
        display: none;
        background: #0b1c16;
        color: #fff;
        padding: 0.55rem 1rem;
        border-radius: 999px;
        font-weight: 700;
        text-decoration: none;
        font-size: 0.86rem;
        box-shadow: none;
        text-shadow: none;
        letter-spacing: -0.01em;
        transition: background 0.15s ease;
      }

      .mobile-download-btn:hover,
      .mobile-download-btn:active {
        background: #0f3d32;
        transform: none;
        box-shadow: none;
      }

      .mobile-menu-toggle {
        display: none;
        flex-direction: column;
        justify-content: space-between;
        width: 40px;
        height: 40px;
        cursor: pointer;
        z-index: 1001;
        padding: 10px;
        border-radius: 10px;
        background: #d8fbe8;
        box-shadow: none;
        transition: background 0.15s ease;
      }

      .mobile-menu-toggle:hover {
        background: #c5f5db;
        transform: none;
        box-shadow: none;
      }

      .mobile-menu-toggle span {
        display: block;
        height: 2px;
        width: 100%;
        background-color: #0b1c16;
        border-radius: 3px;
        transition: transform 0.2s ease, opacity 0.2s ease;
      }

      .nav-container.menu-open .mobile-menu-toggle {
        background: #fff9c4;
      }

      .nav-container.menu-open .mobile-menu-toggle span:nth-child(1) {
        transform: translateY(8px) rotate(45deg);
      }

      .nav-container.menu-open .mobile-menu-toggle span:nth-child(2) {
        opacity: 0;
      }

      .nav-container.menu-open .mobile-menu-toggle span:nth-child(3) {
        transform: translateY(-8px) rotate(-45deg);
      }

      @media (max-width: 768px) {
        .mobile-menu-toggle {
          display: flex;
        }

        .mobile-download-btn {
          display: inline-flex;
          align-items: center;
        }

        .nav-inner {
          justify-content: space-between;
          align-items: center;
        }

        .nav-links {
          position: fixed;
          top: 0;
          right: -100%;
          width: min(240px, 82vw);
          height: auto;
          max-height: 80vh;
          margin: 4.75rem 0.85rem 0 0;
          background: rgba(255, 255, 255, 0.96);
          backdrop-filter: blur(16px);
          -webkit-backdrop-filter: blur(16px);
          display: flex;
          flex-direction: column;
          align-items: stretch;
          gap: 0.35rem;
          transition: right 0.25s ease;
          box-shadow: 0 12px 40px rgba(11, 28, 22, 0.12);
          z-index: 1000;
          padding: 1rem;
          border-radius: 16px;
          border: 1px solid rgba(11, 28, 22, 0.07);
        }

        .nav-container.menu-open .nav-links {
          right: 0;
        }

        .nav-links a {
          color: #5c6f66;
          font-size: 0.95rem;
          padding: 0.65rem 0.4rem;
          width: 100%;
          text-align: left;
          border-bottom: 1px solid rgba(11, 28, 22, 0.06);
        }

        .nav-links a:last-child {
          border-bottom: none;
        }

        .nav-links a::after {
          display: none;
        }

        .nav-cta {
          margin: 0.35rem 0 0 !important;
          width: 100%;
          text-align: center;
          border-bottom: none !important;
          padding: 0.7rem 1rem !important;
          border-radius: 999px !important;
        }

        .nav-links a.nav-cta {
          background: #0b1c16 !important;
          color: #fff !important;
          font-weight: 700;
          box-shadow: none !important;
          text-shadow: none !important;
        }

        .nav-links a.nav-cta:hover {
          background: #0f3d32 !important;
          transform: none !important;
          box-shadow: none !important;
        }
      }
    `;
    document.head.appendChild(mobileStyleElement);
  }

  // Home only: reveal sticky nav after scrolling past the top logo (legacy pages)
  const logoDiv = document.querySelector('#hero .logodiv') || document.querySelector('.logodiv');
  if (logoDiv && isHome) {
    const navObserver = new IntersectionObserver(function (entries) {
      if (!entries[0]) return;
      if (entries[0].isIntersecting) {
        navContainer.classList.remove('visible');
      } else {
        navContainer.classList.add('visible');
      }
    }, { threshold: 0, rootMargin: '0px' });
    navObserver.observe(logoDiv);
  }

  const menuToggle = document.querySelector('.mobile-menu-toggle');
  if (menuToggle) {
    if (!menuToggle.hasAttribute('aria-expanded')) {
      menuToggle.setAttribute('aria-expanded', 'false');
    }

    function setMenuOpen(open) {
      navContainer.classList.toggle('menu-open', open);
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    }

    menuToggle.addEventListener('click', function () {
      setMenuOpen(!navContainer.classList.contains('menu-open'));
    });

    menuToggle.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        setMenuOpen(!navContainer.classList.contains('menu-open'));
      } else if (e.key === 'Escape') {
        setMenuOpen(false);
      }
    });

    document.querySelectorAll('.nav-links a').forEach(function (link) {
      link.addEventListener('click', function () {
        setMenuOpen(false);
      });
    });

    document.addEventListener('click', function (event) {
      const isClickInsideMenu = event.target.closest('.nav-links');
      const isClickOnToggle = event.target.closest('.mobile-menu-toggle');
      if (!isClickInsideMenu && !isClickOnToggle && navContainer.classList.contains('menu-open')) {
        setMenuOpen(false);
      }
    });
  }

  // Prefer the matching store for this device on nav Download buttons
  const prefersApple = /iPhone|iPad|iPod|Macintosh/.test(navigator.userAgent);
  const preferredStore = prefersApple ? storeIos : storeAndroid;
  document.querySelectorAll('.nav-cta, .mobile-download-btn').forEach(function (el) {
    if (el && el.getAttribute('href')) {
      el.setAttribute('href', preferredStore);
    }
  });
});
